(() => {
  const visibleDialogControl = (item, dialog) => {
    if (!item.getClientRects().length || item.closest('[hidden],[inert]') || getComputedStyle(item).visibility === 'hidden') return false;
    // Closed disclosures keep their own summary in the Tab order; everything
    // under a closed ancestor remains excluded even if a browser exposes boxes.
    for (let ancestor = item.parentElement; ancestor && ancestor !== dialog; ancestor = ancestor.parentElement) {
      if (ancestor.tagName === 'DETAILS' && !ancestor.open && ancestor.querySelector(':scope > summary') !== item) return false;
    }
    return true;
  };
  const bind = () => {
    document.querySelectorAll('[data-g-header]:not([data-enhanced])').forEach(header => {
      const preview = document.body.dataset.gThemeId;
      header.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, location.origin);
        if (preview && url.origin === location.origin && !/^\/(account|checkout|policies)(\/|$)/.test(url.pathname)) {
          url.searchParams.set('preview_theme_id', preview);
          link.href = url.href;
        }
      });
      header.querySelectorAll('[data-g-dialog-open]').forEach(opener => {
        const dialog = header.querySelector('#' + opener.dataset.gDialogOpen);
        if (!dialog) return;
        opener.setAttribute('aria-controls', dialog.id);
        opener.setAttribute('aria-expanded', 'false');
        opener.addEventListener('click', event => {
          if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          dialog.showModal();
          opener.setAttribute('aria-expanded', 'true');
          dialog.querySelector('button,a[href]')?.focus();
        });
        dialog.addEventListener('close', () => {
          opener.setAttribute('aria-expanded', 'false');
          const returnFocus = [opener, header.querySelector('.g-header-logo')].find(item => item?.isConnected && item.getClientRects().length && !item.closest('[hidden],[inert]') && getComputedStyle(item).visibility !== 'hidden');
          returnFocus?.focus();
        });
        dialog.querySelectorAll('[data-g-dialog-close]').forEach(close => close.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),summary,[tabindex="0"]')].filter(item => visibleDialogControl(item, dialog));
          const first = items[0];
          const last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
      });
      header.dataset.enhanced = 'true';
    });
  };
  document.addEventListener('theme:cart:change', event => {
    const count = event.detail?.cartCount;
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-g-header] [data-g-cart-count]').forEach(counter => { counter.textContent = String(count); });
    document.querySelectorAll('[data-g-header] [data-g-cart-label]').forEach(link => { link.setAttribute('aria-label', link.dataset.gCartLabel.replace('__COUNT__', String(count))); });
  });
  document.addEventListener('shopify:section:load', bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
  if (new URL(location.href).searchParams.get('g_audit') === '1' && document.body.dataset.gAuditUrl && !document.querySelector('[data-g-audit-loader]')) {
    const audit = document.createElement('script');
    audit.src = document.body.dataset.gAuditUrl;
    audit.dataset.gAuditLoader = 'true';
    document.head.append(audit);
  }
})();
